// articlesData.js
import article1 from './articles/article1/index.js'
export const articlesData = [
    {
        id: '1',
        image: article1.image,
        title: article1.title,
        content: article1.content,
    }
    // ,
    // {
    //     id: '2',
    //     title: 'บทความที่ 2',
    //     content: 'เนื้อหาของบทความที่ 2'
    // },
    // {
    //     id: '3',
    //     title: 'บทความที่ 3',
    //     content: 'เนื้อหาของบทความที่ 3'
    // }
];
